export type DwimTheme = {
  foreground: string;
  background: string;
  /** Caption fill when no per-bubble tone/fill is set. Falls back to `background`. */
  bubble?: string;
};
export type DwimSize = "hero" | "companion" | number;

export const themes = {
  paper: { foreground: "#1A1A1A", background: "#F8F4EC" } satisfies DwimTheme,
  app: { foreground: "#1A1A1A", background: "transparent" } satisfies DwimTheme,
};

/** Named caption fills for warnings, success, and similar callouts. */
export const bubbleFills = {
  default: "",
  warning: "#FECACA",
  success: "#BBF7D0",
  info: "#BFDBFE",
  caution: "#FDE68A",
} as const;

export type BubbleTone = keyof typeof bubbleFills;

export type CaptionOptions = {
  fill?: string;
  tone?: BubbleTone;
  /** Hold duration in ms after the bubble is fully open. `0` stays until `silence()`. */
  holdMs?: number;
};

export function resolveBubbleFill(theme: DwimTheme, options?: CaptionOptions): string {
  if (options?.fill) return options.fill;
  if (options?.tone && options.tone !== "default") return bubbleFills[options.tone];
  const base = theme.bubble ?? theme.background;
  if (base === "transparent" || base === "none" || base === "") return "#FFFFFF";
  return base;
}

export function pixelSize(size: DwimSize): number {
  if (size === "companion") return 80;
  if (size === "hero") return 240;
  return size;
}
